<template>
  <coozzy-card :title="$t('message.marketingSettings.senderEmailViewingAppointment.title')">
    <div class="row">
      <div class="col-12">
        <p class="text-muted">
          {{ $t('message.marketingSettings.senderEmailViewingAppointment.description') }}
        </p>
      </div>
      <div class="col-sm-3 col-md-3 mb-2">
        <label>{{ $t('message.marketingSettings.senderEmailViewingAppointment.mailbox') }}</label>
        <coozzy-form-select
          v-model="selectedMailbox"
          :disabled="loading">
          <option
            value="">
            -
          </option>
          <option
            v-for="mailbox in mailBoxList"
            :key="mailbox.id"
            :value="mailbox.id">
            {{ mailbox.outboundEmail }}
          </option>
        </coozzy-form-select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <coozzy-button
          class="float-right mt-3"
          design="primary"
          :disabled="loading"
          @click="saveClicked">
          {{ $t('message.generic.form.save') }}
        </coozzy-button>
      </div>
    </div>
  </coozzy-card>
</template>

<script>
import Vue from 'vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CalendarSchedulerApi from '@/misc/apis/CalendarSchedulerApi'
import MessageApi from '@/misc/apis/MessageApi'
import { user } from '@/mixins/user'

export default {
  name: 'ViewingAppointmentSenderEmailSettings',
  components: { CoozzyButton, CoozzyFormSelect, CoozzyCard },
  mixins: [user],
  data() {
    return {
      loading: false,
      selectedMailbox: '',
      mailBoxList: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      Promise.all([
        this.loadMailboxes(),
        this.loadSenderMailbox()
      ]).then(() => {
        this.reconcileSelectedMailbox()
      }).finally(() => {
        this.loading = false
      })
    },
    loadMailboxes() {
      const request = this.isCompanyAdmin
        ? MessageApi.listMailboxes(this.accountId)
        : MessageApi.listMailboxesByUserId(this.$store.getters['user/getUserId'])
      return request
        .then(response => {
          // The ticket asks for the activated mailboxes only.
          this.mailBoxList = (response.mailboxes || []).filter(mailbox => mailbox.active)
        })
        .catch(() => {
          Vue.toasted.show(this.$t('message.loadingErrors.mailbox'), { type: 'error' })
        })
    },
    loadSenderMailbox() {
      return CalendarSchedulerApi.getSenderMailbox(this.accountId)
        .then(response => {
          this.selectedMailbox = response.mailboxId || ''
        })
        .catch(e => {
          // Nothing configured yet is the normal starting state, not an error worth a toast.
          if (!e.response || e.response.status !== 404) {
            Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
          }
        })
    },
    reconcileSelectedMailbox() {
      if (!this.selectedMailbox) {
        return
      }
      const stillActive = this.mailBoxList.some(mailbox => mailbox.id === this.selectedMailbox)
      if (!stillActive) {
        this.selectedMailbox = ''
      }
    },
    saveClicked() {
      this.loading = true
      // An empty mailboxId is a valid value: it clears the setting and falls back to the
      // PROPbase generated no-reply address.
      CalendarSchedulerApi.setSenderMailbox({
        accountId: this.accountId,
        mailboxId: this.selectedMailbox || ''
      }).then(() => {
        Vue.toasted.show(this.$t('message.marketingSettings.senderEmailViewingAppointment.savedSuccessfully'), { type: 'success' })
      }).catch(() => {
        Vue.toasted.show(this.$t('message.marketingSettings.senderEmailViewingAppointment.savedFailed'), { type: 'error' })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
